export default "__VITE_ASSET__WVagXgMb__"